import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { ThemeProvider } from 'styled-components'
import { theme } from '@weirgroup/weir-dls'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals'
import './locale/i18n'

/// <reference types="node" />
import { Provider, ReactReduxContext } from 'react-redux'
import store from './redux/store'

// Make Buffer available globally
// SonarLint disable-next-line: import-path
globalThis.Buffer = globalThis.Buffer || require("buffer").Buffer;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <Provider store={store} context={ReactReduxContext}>
                <Router>
                    <App />
                </Router>
            </Provider>
        </ThemeProvider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
